export const firebaseConfig = {
  apiKey: 'AIzaSyCBSoRuytmwCHFGmepGKZb_1b5nsz4K-zQ',
  authDomain: 'c4t-test.firebaseapp.com',
  databaseURL: 'https://c4t-test.firebaseio.com',
  projectId: 'c4t-test',
  storageBucket: 'c4t-test.appspot.com',
  messagingSenderId: '62021415739',
  appId: '1:62021415739:web:d213226b1e30a3a2e6bd1e',
  measurementId: 'G-7N9GQH7NJZ',
};

export const appURL = 'http://localhost:8080/#';
export const cloudFunctions = 'https://us-central1-c4t-test.cloudfunctions.net';
export const cloudFunctionsBackoffice =
  'https://us-central1-backoffice-c4t.cloudfunctions.net';

export const webPushId = 'web.chance4talents.push';

export const stripePublicKey = 'pk_test_Rtg7JAvi1y1a45fOAaF4sYEv00AFtQljpb';

export const paypalConfig = {
  clientId:
    'Ad18P3TF5jA4uRd_LGjKF-LJGbugL7ICA8YdsOtk4p2uxRV1wLG3jSCt_S0fgoo6EQ7o5_EkD-PJPABo',
};

export const subscriptions = {
  scouts: [
    {
      id: 'price_1NpsG1DRZSOKB8ceK7J8PfMi',
      paypalId: 'P-80E40206FU0466420MUCE6QQ',
      name: '3 Monate',
      price: '399,00€ *',
      value: 39900,
    },
    {
      id: 'price_1NpsJGDRZSOKB8ceKvg909Zy',
      paypalId: 'P-16K63314CX212491GMUCE7BY',
      name: '12 Monate',
      price: '899,00€ *',
      value: 89900,
      mostSelected: true,
    },
    {
      id: 'price_1NpsIZDRZSOKB8ceWDi8A2In',
      paypalId: 'P-9B954460Y0997645WMUCE6ZI',
      name: '6 Monate',
      price: '599,00€ *',
      value: 59900,
    },
  ],
  teams: [
    // {
    //   id: 'price_1JxRo9DRZSOKB8ceAW8CnOPF', name: 'monatlich', price: '12,42€ *', value: 1242, mostSelected: true, league: ['9', '10'], type: 'monthly',
    // },
    // {
    //   id: 'price_1JxRnTDRZSOKB8ceUKTCNvI2', name: 'monatlich', price: '16,60€ *', value: 1660, mostSelected: true, league: ['8', '81'], type: 'monthly',
    // },
    // {
    //   id: 'price_1JxRmrDRZSOKB8cemoVnhfYe', name: 'monatlich', price: '24,90€ *', value: 2490, mostSelected: true, league: ['7', '71'], type: 'monthly',
    // },
    // {
    //   id: 'price_1JxRmDDRZSOKB8ce8QlipAIU', name: 'monatlich', price: '41,60€ *', value: 4160, mostSelected: true, league: ['6', '61'], type: 'monthly',
    // },
    // {
    //   id: 'price_1JxRlLDRZSOKB8cef8f5Bn26', name: 'monatlich', price: '66,60€ *', value: 6660, mostSelected: true, league: ['5'], type: 'monthly',
    // },
    // {
    //   id: 'price_1JxRffDRZSOKB8cezSWz1Q5E', name: 'monatlich', price: '108,25€ *', value: 10825, mostSelected: true, league: ['4'], type: 'monthly',
    // },
    {
      id: 'price_1JxRYSDRZSOKB8cernaXo3tx',
      name: 'einmalig',
      price: '149,00€ *',
      value: 14900,
      league: ['9', '10'],
      type: 'saison',
    },
    {
      id: 'price_1JxRXxDRZSOKB8cekzKxNpaB',
      name: 'einmalig',
      price: '199,00€ *',
      value: 19900,
      league: ['8', '81'],
      type: 'saison',
    },
    {
      id: 'price_1JxRXWDRZSOKB8ceBcgh6GuX',
      name: 'einmalig',
      price: '299,00€ *',
      value: 29900,
      league: ['7', '71'],
      type: 'saison',
    },
    {
      id: 'price_1JxRWtDRZSOKB8ce7BNVT11j',
      name: 'einmalig',
      price: '499,00€ *',
      value: 49900,
      league: ['6', '61'],
      type: 'saison',
    },
    {
      id: 'price_1JxRWQDRZSOKB8cein05DCDo',
      name: 'einmalig',
      price: '799,00€ *',
      value: 79900,
      league: ['5'],
      type: 'saison',
    },
    {
      id: 'price_1JxRVfDRZSOKB8ceffCOBxOr',
      name: 'einmalig',
      price: '1299,00€ *',
      value: 129900,
      league: ['4'],
      type: 'saison',
    },
  ],
};
export const paymentPackages = [
  {
    id: 1,
    name: '5 SWIPES',
    price: '2,49€',
    value: 249,
    swipes: 5,
  },
  {
    id: 2,
    name: '10 SWIPES',
    price: '3,99€',
    value: 399,
    swipes: 10,
  },
  {
    id: 3,
    name: '25 SWIPES',
    price: '9,99€',
    value: 999,
    swipes: 25,
  },
  {
    id: 4,
    name: '75 SWIPES',
    price: '24,99€',
    value: 2499,
    swipes: 75,
  },
  {
    id: 5,
    name: 'SWIPES unlimited',
    price: '99,99€ *',
    value: 9999,
    swipes: 9000000,
  },
];

export const paymentPackagesLeague = [
  {
    id: 'price_1JxRYSDRZSOKB8cernaXo3tx',
    name: 'einmalig',
    price: '149,00€ *',
    value: 14900,
    league: ['9', '10'],
    type: 'saison',
  },
  {
    id: 'price_1JxRXxDRZSOKB8cekzKxNpaB',
    name: 'einmalig',
    price: '199,00€ *',
    value: 19900,
    league: ['8', '81'],
    type: 'saison',
  },
  {
    id: 'price_1JxRXWDRZSOKB8ceBcgh6GuX',
    name: 'einmalig',
    price: '299,00€ *',
    value: 29900,
    league: ['7', '71'],
    type: 'saison',
  },
  {
    id: 'price_1JxRWtDRZSOKB8ce7BNVT11j',
    name: 'einmalig',
    price: '499,00€ *',
    value: 49900,
    league: ['6', '61'],
    type: 'saison',
  },
  {
    id: 'price_1JxRWQDRZSOKB8cein05DCDo',
    name: 'einmalig',
    price: '799,00€ *',
    value: 79900,
    league: ['5'],
    type: 'saison',
  },
  {
    id: 'price_1JxRVfDRZSOKB8ceffCOBxOr',
    name: 'einmalig',
    price: '1299,00€ *',
    value: 129900,
    league: ['4'],
    type: 'saison',
  },
];
